import { render, staticRenderFns } from "./StatementsList.vue?vue&type=template&id=7c8e7348&"
import script from "./StatementsList.vue?vue&type=script&lang=js&"
export * from "./StatementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports